import React from 'react'
import { Link } from 'react-router-dom'

interface DepositPageHeaderProps {
  balanceText: string
  pointsText: string
  userBankSummaryText: string
  /** ซ่อนการ์ดยอดเครดิต/คะแนน/ปุ่มฝาก-ถอน — ใช้บนหน้า /topup ลดความเกะกะ */
  showSummaryCard?: boolean
}

const DepositPageHeader: React.FC<DepositPageHeaderProps> = ({
  balanceText,
  pointsText,
  userBankSummaryText,
  showSummaryCard = true,
}) => {
  return (
    <>
      <div className="c_quinary text-center">
        <h3 className="c_tertiary font_md">ฝากเงิน</h3>
      </div>

      {showSummaryCard && (
      <div className="col-12 px-2">
        <div className="light_sd bg_op_secondary align-items-center bdc_primary p-3 p-md-4 border_30">
          <div className="box_cd mx-auto text-center c_tertiary">
            <h6 className="">ยอดเครดิตของคุณ</h6>
            <h1 className="font_md my-3 bg_secondary c_primary border_5">{balanceText}</h1>
            <h5 className="c_quinary">
              คะแนนของคุณ : <span className="c_tertiary font_md">{pointsText}</span>
            </h5>
            <h6 className="mx-auto" style={{ width: 'fit-content' }}>
              <Link to="/points" className="c_warning txt_links_primary text-decoration-none">
                <u>ดูคะแนนทั้งหมด</u>
              </Link>
            </h6>
          </div>
          <div className="line_btw mt-4 mb-3 mx-auto" />
          <div className="row mx__1">
            <div className="col-12 col-md-5 offset-md-1 px-1 mt-2">
              <span className="link_pmr box_row justify-content-center font_rg bg_primary gap-3 border_30 ins_sd ft_sd d-inline-flex w-100 text-decoration-none c_tertiary">
                <h5 className="c_tertiary mb-0">ฝากเงิน</h5>
              </span>
            </div>
            <div className="col-12 col-md-5 px-1 mt-2">
              <Link
                to="/withdraw"
                className="link_pmr box_row justify-content-center font_rg bg_secondary gap-3 border_30 ins_sd ft_sd w-100 text-decoration-none"
              >
                <h5 className="c_secondary mb-0">ถอนเงิน</h5>
              </Link>
            </div>
          </div>
          <h6 className="c_quinary text-center mt-4">ข้อมูลบัญชีของคุณ :</h6>
          <h5 className="c_tertiary font_md text-center">{userBankSummaryText}</h5>
        </div>
      </div>
      )}
    </>
  )
}

export default DepositPageHeader
